
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[areaId]/events",
      function () {
        return require("private-next-pages/[areaId]/events/index.tsx");
      }
    ]);
  